import { Action, Module, VuexModule } from "vuex-module-decorators";
import { QueueNumber } from "@/store/enums/StoreEnums";
import ApiService from "@/core/services/ApiService";

@Module
export default class QueueNumberModule extends VuexModule {
    @Action
    [QueueNumber.getQueueNumber]() {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/queue-number/assignNumberForTeller`, {})
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [QueueNumber.callSpeaker](params) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/queue-number/callSpeaker`, params)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [QueueNumber.completeProcess](params) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/queue-number/completeProcess`, params)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [QueueNumber.cancelProcess](params) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/queue-number/cancelProcess`, params)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [QueueNumber.transferTicket](params) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/queue-number/transferTicket`, params)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [QueueNumber.getQueueList](params) {
        return new Promise<void>((resolve, reject) => {
            ApiService.get(`/queue-number/getQueueList`)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [QueueNumber.getDailyStatsByEmployee](params) {
        return new Promise<void>((resolve, reject) => {
            ApiService.get(`/queue-number/getDailyStatsByEmp`)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [QueueNumber.getProcessingQueueList](params) {
        return new Promise<void>((resolve, reject) => {
            ApiService.get(`/queue-number/getProcessingQueueList`)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [QueueNumber.getProcessingQueue](params) {
        return new Promise<void>((resolve, reject) => {
            ApiService.get(`/queue-number/getProcessingQueue`)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [QueueNumber.byPassQueueNumber](params) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/queue-number/byPassQueueNumber`, params)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [QueueNumber.transferTicket2](params) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/queue-number/transferTicket2`, params)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [QueueNumber.getProcessingQueueByBooth](params) {
        return new Promise<void>((resolve, reject) => {
            ApiService.get(`/queue-number/getProcessingQueueByBooth`)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

}